import { render, staticRenderFns } from "./StatusBadge.vue?vue&type=template&id=21996d90&lang=pug&"
import script from "./StatusBadge.vue?vue&type=script&lang=ts&"
export * from "./StatusBadge.vue?vue&type=script&lang=ts&"
import style0 from "./StatusBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports